export default __webpack_public_path__ + "static/media/i113jp.099f96ef.webp";